/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDateReportQueryResponse, GetStatsByDateReportQueryParams, GetStatsByDateReport400 } from '../entities/GetStatsByDateReport'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDateReportUrl() {
  return `/stats/by-date/report` as const
}

/**
 * @description Получение отчета по статистике по дням
 * @summary Получение отчета по статистике по дням
 * {@link /stats/by-date/report}
 */
export async function getStatsByDateReport(params?: GetStatsByDateReportQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDateReportQueryResponse, ResponseErrorConfig<GetStatsByDateReport400>, unknown>({
    method: 'GET',
    url: getGetStatsByDateReportUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}